import React, { useState } from "react";
import axios from "axios";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { isOnlineMode } from "../../../utils/onlineStatus";
import {  saveCustomer } from "../../../utils/localDB";


const CustomerCreate = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("gst");
  const [showShippingAddress, setShowShippingAddress] = useState(false);
  const [blockCustomer, setBlockCustomer] = useState("no");

  // Form state
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    type: "b2b",
    registration_type: "unregistered",
    tax_num: "",
    state: "",
    billing_address: "",
    shipping_address: "",
    opening_type: "credit",
    opening_amount: "",
    opening_date: "",
    block_customer: "no",
    credit_limit_days: "",
    credit_limit_amount: "",
    notes: "",
    price_level_applicable: false,
  });

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
  try {
    if (isOnlineMode()) {
      // Online mode → save to server
      await axios.post("/api/customers", form);
    } else {
      // Offline mode → save to local IndexedDB
      await saveCustomer(form);
    }
    navigate(-1);
  } catch (err) {
    console.error("Error adding customer:", err);
  }
};

  const handleClose = () => {
    if (window?.process?.type) {
      window.close();
    } else {
      navigate(-1);
    }
  };

  return (
    <Main>
      <Header>
        <Title>Add Customer</Title>
      </Header>

      <FormContainer>
        {/* First Row */}
        <Row>
          <InputGroup>
            <Label>Customer Name</Label>
            <Input value={form.name} onChange={e => handleChange("name", e.target.value)} required/>
          </InputGroup>
          <InputGroup>
            <Label>Phone Number</Label>
            <Input value={form.phone} onChange={e => handleChange("phone", e.target.value)} />
          </InputGroup>
          <InputGroup>
            <Label>Email ID</Label>
            <Input value={form.email} onChange={e => handleChange("email", e.target.value)} />
          </InputGroup>
        </Row>

        {/* Tabs */}
        <Tabs>
          <Tab active={activeTab === "gst"} onClick={() => setActiveTab("gst")}>
            Tax & Address
          </Tab>
          <Tab active={activeTab === "credit"} onClick={() => setActiveTab("credit")}>
            Opening & Billwise
          </Tab>
          <Tab active={activeTab === "additional"} onClick={() => setActiveTab("additional")}>
            Additional Fields
          </Tab>
        </Tabs>

        <TabContent>
          {activeTab === "gst" && (
            <>
              <Row>
                <InputGroup>
                  <Label>Customer Type</Label>
                  <Select value={form.type} onChange={e => handleChange("type", e.target.value)}>
                    <option value="b2b">B2B Customer</option>
                    <option value="b2c">B2C Customer</option>
                  </Select>
                </InputGroup>
                <InputGroup>
                  <Label>Tax Type</Label>
                  <Select value={form.registration_type} onChange={e => handleChange("registration_type", e.target.value)}>
                    <option value="unregistered">Unregistered/Consumer</option>
                    <option value="registered">Registered Business</option>
                  </Select>
                </InputGroup>
                <InputGroup>
                  <Label>Tax Number</Label>
                  <Input value={form.tax_num} onChange={e => handleChange("tax_num", e.target.value)} />
                </InputGroup>
                <InputGroup>
                  <Label>State</Label>
                  <Select value={form.state} onChange={e => handleChange("state", e.target.value)}>
                    <option value="">Select State</option>
                    <option value="Kerala">Kerala</option>
                    <option value="Karnataka">Karnataka</option>
                  </Select>
                </InputGroup>
              </Row>
              <Row>
                <InputGroup fullWidth>
                  <Label>Billing Address</Label>
                  <Textarea rows="3" value={form.billing_address} onChange={e => handleChange("billing_address", e.target.value)} />
                </InputGroup>
              </Row>
              {!showShippingAddress ? (
                <EnableLink onClick={() => setShowShippingAddress(true)}>
                  + Enable Shipping Address
                </EnableLink>
              ) : (
                <DisableLink onClick={() => setShowShippingAddress(false)}>
                  − Disable Shipping Address
                </DisableLink>
              )}

              {showShippingAddress && (
                <Row>
                  <InputGroup fullWidth>
                    <Label>Shipping Address</Label>
                    <Textarea rows="3" value={form.shipping_address} onChange={e => handleChange("shipping_address", e.target.value)} />
                  </InputGroup>
                </Row>
              )}
            </>
          )}

          {activeTab === "credit" && (
            <>
              <Row>
                <InputGroup>
                  <Label>Type</Label>
                  <Select value={form.opening_type} onChange={e => handleChange("opening_type", e.target.value)}>
                    <option value="credit">Credit</option>
                    <option value="debit">Debit</option>
                  </Select>
                </InputGroup>
                <InputGroup>
                  <Label>Opening Balance</Label>
                  <Input value={form.opening_amount} onChange={e => handleChange("opening_amount", e.target.value)} />
                </InputGroup>
                <InputGroup>
                  <Label>Opening Balance Date</Label>
                  <Input type="date" value={form.opening_date} onChange={e => handleChange("opening_date", e.target.value)} />
                </InputGroup>
              </Row>
              <Row>
                <InputGroup>
                  <Label>Block Customer</Label>
                  <Select value={form.block_customer} onChange={e => handleChange("block_customer", e.target.value)}>
                    <option value="no">No</option>
                    <option value="on_limit">On Credit Limit</option>
                    <option value="on_days">On Credit Days</option>
                    <option value="on_both">On Both</option>
                  </Select>
                </InputGroup>

                {(form.block_customer === "on_limit" || form.block_customer === "on_both") && (
                  <InputGroup>
                    <Label>Credit Limit</Label>
                    <Input value={form.credit_limit_amount} onChange={e => handleChange("credit_limit_amount", e.target.value)} />
                  </InputGroup>
                )}

                {(form.block_customer === "on_days" || form.block_customer === "on_both") && (
                  <InputGroup>
                    <Label>Credit Days</Label>
                    <Input value={form.credit_limit_days} onChange={e => handleChange("credit_limit_days", e.target.value)} />
                  </InputGroup>
                )}
              </Row>
            </>
          )}

          {activeTab === "additional" && (
            <Row>
              <InputGroup fullWidth>
                <Label>Notes</Label>
                <Textarea rows="3" value={form.notes} onChange={e => handleChange("notes", e.target.value)} />
              </InputGroup>
              <InputGroup>
                <Label>Price Level Applicable</Label>
                <input type="checkbox" checked={form.price_level_applicable} onChange={e => handleChange("price_level_applicable", e.target.checked)} />
              </InputGroup>
            </Row>
          )}
        </TabContent>

        {/* Buttons */}
        <ButtonRow>
          <ButtonOutline onClick={handleClose}>Cancel</ButtonOutline>
          <ButtonPrimary onClick={handleSubmit}>Save</ButtonPrimary>
        </ButtonRow>
      </FormContainer>
    </Main>
  );
};

export default CustomerCreate;

// ... keep your styled-components code ...


/* Styles */
const Main = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  height: 100%;
`;

const Header = styled.div`
  padding: 12px 20px;
  border-bottom: 1px solid #ddd;
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #000;
`;

const FormContainer = styled.div`
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

const InputGroup = styled.div`
  flex: ${({ fullWidth }) => (fullWidth ? "1 1 100%" : "1")};
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-size: 13px;
  color: #000;
  margin-bottom: 6px;
`;

const Input = styled.input`
  padding: 8px;
  border: 1px solid #ccc;
  font-size: 14px;
  border-radius: 4px;
  outline: none;
  &:focus {
    border-color: #000;
  }
`;

const Select = styled.select`
  padding: 8px;
  border: 1px solid #ccc;
  font-size: 14px;
  border-radius: 4px;
  outline: none;
  background: #fff;
  &:focus {
    border-color: #000;
  }
`;

const Textarea = styled.textarea`
  padding: 8px;
  border: 1px solid #ccc;
  font-size: 14px;
  border-radius: 4px;
  resize: none;
  outline: none;
  &:focus {
    border-color: #000;
  }
`;

const Tabs = styled.div`
  display: flex;
  border-bottom: 1px solid #ddd;
  margin-bottom: 16px;
`;

const Tab = styled.div`
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  border-bottom: ${({ active }) => (active ? "2px solid #000" : "none")};
  color: ${({ active }) => (active ? "#000" : "#555")};
  font-weight: ${({ active }) => (active ? "600" : "400")};
`;

const TabContent = styled.div`
  flex: 1;
`;

const EnableLink = styled.a`
  font-size: 13px;
  color: #000;
  cursor: pointer;
  text-decoration: none;
`;

const DisableLink = styled.a`
  font-size: 13px;
  color: #fe6666;
  cursor: pointer;
  text-decoration: none;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: auto;
`;

const ButtonPrimary = styled.button`
  padding: 8px 16px;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

const ButtonOutline = styled.button`
  padding: 8px 16px;
  background: #fff;
  color: #000;
  border: 1px solid #000;
  border-radius: 4px;
  cursor: pointer;
`;
